import React, {useState, useEffect, useCallback} from 'react';
import styled from 'styled-components';
import Formsy from 'formsy-react';
import { Link } from "react-router-dom";
import {useDispatch} from 'react-redux';
import _ from 'lodash';
import { getItem } from '../../utils/handleStorage';
import { V2_ACTIVE_COLOR, V2_BUTTON_COLOR } from '../../config/color';
import logo from "../../assets/image/Treasurer.png";
import HeartIcon from '../../assets/image/heart.png';
import LockIcon from '../../assets/image/lock.png';
import KeyVisualIcon from '../../assets/image/keyVisual.png';
import { login } from '../../redux/actions/authAction';

const LeftTop = styled.div``;
const Image = styled.img``;
const ImageContainer = styled(Link)``;
const SLink = styled(Link)``;

const LeftBottom = styled.div``;
const LoginContainer = styled.div``;
const ServiceContainer = styled.div``;

const InputWrap = styled.div``;

const Wrap = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;
  }
`

const LeftWrap = styled.div`
  display: flex;
  /* flex: 2; */
  width: 380px;
  padding: 0 40px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`

const LeftContainer = styled.div`
  margin-top: 170px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    margin-top: 0px;
  }

  ${LeftTop} {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
      margin-bottom: 30px;
    }
    p {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;

      @media (max-width: 768px) {
        font-size: 16px;
        line-height: 20px;
      }
    }
    ${ImageContainer} {
      width: 120px;
      margin-bottom: 30px;
      @media (max-width: 768px) {
        margin-top: 0px;
      }

      ${Image} {
        width: 100%;
      }
    }
  }

  ${LeftBottom} {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
      margin-bottom: 30px;
    }

    ${LoginContainer} {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;

      @media (max-width: 768px) {
        font-size: 16px;
      }

      ${InputWrap} {
        width: 100%;
        margin-bottom: 20px;
        
        label {
          color: #74777E;
          margin-bottom: 10px;
          font-size: 16px;
          display: inline-block;

          @media (max-width: 768px) {
            font-size: 14px;
            margin-bottom: 6px;
          }
        }

        input {
          width: 100%;
          padding: 16px 24px;
          background-color: #EEEFF2;
          border-radius: 10px;
          background-color: white;

          ::placeholder {
            color: #AEAEAE;
            font-size: 14px;
            line-height: 20px;
          }
        }

        span {
          font-size: 12px;
          font-weight: 600;
          color: rgba(255, 110, 48, 0.8);
          @media (max-width: 768px) {
            font-size: 10px;
          }
        }
      }

      p {
        width: 100%;
        margin-bottom: 30px;
        &:is(:nth-child(3)) {
          margin-top: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        span {
          display: inline-block;
          width: 100%;
          font-size: 16px;
          font-weight: 600;
          color: #6A7986;
          margin-bottom: 8px;
        }
        input {
          width: 100%;
          padding: 14px 20px;
          border-radius: 10px;

          ::placeholder {
            color: rgba(110, 117, 124, 0.3);
            font-size: 16px;
            line-height: 24px;
          }
        }
        button {
          background-color: ${V2_BUTTON_COLOR};
          border-radius: 16px;
          padding: 16px 24px;
          font-size: 20px;
          font-weight: 400;
          line-height: 24px;
          color: white;
          cursor: pointer;

          @media (max-width: 768px) {
            padding: 12px 20px;
            font-size: 16px;
          }
          
        }
      }
    }

    ${ServiceContainer} {
      width: 100%;

      div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        ${SLink} {
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          color: ${V2_ACTIVE_COLOR};
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          @media (max-width: 768px) {
            font-size: 12px;
            line-height: 18px;
          }
          
          p {
            &:nth-child(1) {
              width: 16px;
              height: 18px;
              margin-right: 5px;
            }

            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
`

const LeftFooterWrap = styled.div`
  width: 100%;
  border-top: 2px solid rgba(110, 117, 124, 0.3);
  padding: 15px 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
  font-weight: 400;
  color: ${V2_ACTIVE_COLOR};
  
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 18px;
    border-top: 1px solid rgba(110, 117, 124, 0.2);
    padding: 10px 0 20px;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

const RightWrap = styled.div`
  display: flex;
  flex: 8;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  @media (max-width: 768px) {
    display: none;
  }

  div {
    max-width: 900px;

    img {
      width: 100%;
    }
  }
`


export default ({history}) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState({
    email: "",
    password: ""
  });
  const { email, password } = user;
  const [ confirmPasswordError, setConfirmPasswordError ] = useState("");
  const [ notFoundError, setNotFoundError ] = useState('');
  const [ passwordIncorrectError, setPasswordIncorrectError ] = useState('');


  const onChangeInput = e => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  useEffect(() => {
    if(getItem('session')) {
      history.push('/shop/profile');
    }
  })

  const formRef = React.createRef();

  const handleSubmit = useCallback( async () => {
    try {
      const r = await dispatch(login(email, password));
      if(r?.data?.result) {
        history.push('/shop/profile');
      } else if(r?.data?.message === 'not found') {
        setNotFoundError('아이디를 찾을 수 없습니다.');
        // alert(r.data.message)
      } else if(r?.data?.message === 'password is incorrect') {
        setPasswordIncorrectError("비밀번호가 다릅니다.");
      } else {
        alert(r.data.message)
      }
    } catch(e) {
      console.log(e)
    }

  }, [dispatch, email, password])

  const _onInputFocus = () => {
    setNotFoundError("");
    setPasswordIncorrectError("");
  }

  return (
    <Wrap>
      <LeftWrap>
        <LeftContainer>
          <LeftTop>
            <ImageContainer to="/">
              <Image src={logo} alt="logo" />
            </ImageContainer>
            <p>
              <span>트레져러 파트너센터에</span>
              <span>오신 것을 환영합니다.</span>
            </p>
          </LeftTop>
          <LeftBottom>
            <LoginContainer>
              <Formsy
                style={{width: '100%'}}
                onValidSubmit={() => handleSubmit()}
                ref={formRef}
              >
                <InputWrap>
                  <label>이메일 주소</label>
                  <input
                    type="email"
                    name="email"
                    style={{border: notFoundError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                    onChange={onChangeInput}
                    placeholder="이메일 주소를 입력하세요."
                    onFocus={() => _onInputFocus()}
                    value={email}
                  />
                  <span>
                    {notFoundError}
                  </span>
                </InputWrap>
                <InputWrap>
                  <label>비밀번호</label>
                  <input
                    type="password"
                    name="password"
                    style={{border: passwordIncorrectError ? `1px solid ${V2_BUTTON_COLOR}` : 'none'}}
                    onChange={onChangeInput}
                    placeholder={'비밀번호를 입력해주세요.'}
                    onFocus={() => _onInputFocus()}
                    value={password}
                  />
                  <span>
                    {passwordIncorrectError}
                  </span>
                </InputWrap>
                <p>
                  <button type="submit">
                    로그인
                  </button>
                </p>
              </Formsy>
            </LoginContainer>
            <ServiceContainer>
              <div>
                <SLink>
                  <p>
                    <img src={LockIcon} alt="" />
                  </p>
                  <p>비밀번호를 잊으셨나요?</p>
                </SLink>
                <SLink>|</SLink>
                <SLink to="/signup">
                  <p>
                    <img src={HeartIcon} alt="" />
                  </p>
                  <p>파트너 가입하기</p>
                </SLink>
              </div>
            </ServiceContainer>
          </LeftBottom>
        </LeftContainer>
        <LeftFooterWrap>
          <div>
            <p>(주)얼마야</p>
            <div>
              <p>
                <span>사업자 등록번호 527 - 81 - 01503</span>
                <span>&nbsp;|&nbsp;</span>
                <span>대표: 김경태</span>
              </p>
              <p>
                <span>06133 서울 강남구 테헤란로 129 7층</span>
              </p>
              <p>
                <span>개인정보 처리방침</span>
                <span>&nbsp;|&nbsp;</span>
                <span>서비스 이용약관</span>
              </p>
            </div>
          </div>
        </LeftFooterWrap>
      </LeftWrap>
      <RightWrap>
        <div>
          <img src={KeyVisualIcon}/>
        </div>
      </RightWrap>
    </Wrap>
  )
}